var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 363.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.03 44.89c-.14 5.96.87 8.83 6.05 8.84h77.02c35.31 2.77 67.79 16.51 86.88 47.49 11.59 18.8 18.13 45.91 21.68 67.8 1.53 9.46 2.24 18.31.61 22.41-.77 1.93-1.92 3.23-3.47 3.85-8.58 3.43-17.64-8.37-22.46-14.01-24.39-28.52-59.69-38.18-95.8-40.1h-66.32c-4.08.71-5.53 3.72-5.11 8.37v32.1c-.25 10.66-5.62 14.29-16.29 10.69l-98.11-77-12.12-9.51C-3.3 98.73-.05 92.27 7.03 86.7l7.49-5.9 94.01-74.01c11.48-9.04 23.5-11.46 23.5 8.02v30.08zm247.94 273.77c.13-5.97-.87-8.84-6.05-8.84H296.9c-35.31-2.77-67.79-16.51-86.88-47.49-11.59-18.8-18.14-45.91-21.68-67.8-1.53-9.46-2.24-18.31-.61-22.41.77-1.93 1.92-3.23 3.47-3.85 8.58-3.43 17.64 8.36 22.46 14.01 24.39 28.52 59.69 38.18 95.8 40.1h66.32c4.08-.71 5.52-3.73 5.11-8.38v-32.09c.24-10.66 5.62-14.29 16.28-10.69l98.12 76.99 12.12 9.52c7.88 7.09 4.64 13.55-2.44 19.12l-7.49 5.9-94.02 74.01c-11.47 9.04-23.49 11.45-23.49-8.02v-30.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/ExchangeIcon.cda2ad826c4986a69ce53c85f818b70c.svg";
export { ForwardRef as ReactComponent };